import "./utils/timezone";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { registerSW } from "virtual:pwa-register";
import "./api/axiosInterceptor.js";

import App from "./App.jsx";

import "./scss/index.scss";

const updateSW = registerSW({
  onNeedRefresh() {},
  onOfflineReady() {},
});

ReactDOM.createRoot(document.getElementById("root")).render(
  //<React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
  //</React.StrictMode>
);
